
(function () {
  function closestMediaTrigger(target) {
    return target.closest('.product__modal-opener, .product__media-toggle, button[aria-haspopup="dialog"], button[data-media-id]');
  }

  function openProductModal(trigger) {
    var sectionId = null;
    var mediaId = null;

    var mediaItem = trigger.closest('[data-media-id]');
    if (mediaItem) {
      mediaId = mediaItem.getAttribute('data-media-id');
      if (mediaId && mediaId.indexOf('-') > -1) {
        sectionId = mediaId.split('-')[0];
      }
    }

    var gallery = trigger.closest('media-gallery');
    if (gallery && gallery.id && gallery.id.indexOf('MediaGallery-') === 0) {
      sectionId = gallery.id.replace('MediaGallery-', '');
    }

    var modal = null;
    if (sectionId) {
      modal = document.querySelector('product-modal[id="ProductModal-' + sectionId + '"], modal-dialog[id="ProductModal-' + sectionId + '"], #ProductModal-' + sectionId);
    }
    if (!modal) {
      modal = document.querySelector('product-modal[id^="ProductModal-"], modal-dialog[id^="ProductModal-"], [id^="ProductModal-"]');
    }
    if (!modal) return false;

    if (typeof modal.show === 'function') {
      modal.show(trigger);
      return true;
    }

    modal.removeAttribute('hidden');
    modal.setAttribute('open', '');
    modal.classList.add('active');
    document.body.classList.add('overflow-hidden');

    if (mediaId) {
      var target = modal.querySelector('[data-media-id="' + mediaId + '"], #' + CSS.escape(mediaId));
      if (target && typeof target.scrollIntoView === 'function') {
        setTimeout(function () {
          target.scrollIntoView({ block: 'nearest', inline: 'center' });
        }, 60);
      }
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var trigger = closestMediaTrigger(event.target);
    if (!trigger) return;

    var isZoomClick = event.target.closest('.product__media-icon, .product__modal-opener, .product__media-toggle, button[aria-haspopup="dialog"]');
    if (!isZoomClick) return;

    setTimeout(function () {
      var opened = document.querySelector('product-modal[open], modal-dialog[open], product-modal.active, modal-dialog.active, [id^="ProductModal-"].active');
      if (!opened) {
        openProductModal(trigger);
      }
    }, 80);
  }, true);

  document.addEventListener('shopify:section:load', function () {});
})();
